import styled from "styled-components";
import PageNavigation from "../components/PageNavigation";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { MdSecurity } from "react-icons/md";
import { GiCargoShip } from "react-icons/gi";
import { TbTruckDelivery, TbReplace } from "react-icons/tb";
import FormatPrice from "../Helpers/FormatPrice";
import MyImage from "../components/MyImage";
import Foot from "../layout/Foot";
import Star from "../components/Star";
import AddtoCart from "../components/AddtoCart";
import { useProductContext } from "../context/productcontext";
import { ProductDetailsTable } from "../Helpers/ProductDetailsTable";
import { useAuthStore } from '../store/store';




// const API="http://localhost:8080/api/products";
 const API=`${process.env.REACT_APP_SERVER_DOMAIN}/api/products`;


const SingleProduct = () => {
  const{getSingleProducts,isSingleLoading,singleproduct}=useProductContext();
  // console.log(singleproduct);
 
  const { id } = useParams();
  const {auth}=useAuthStore();  

  useEffect(() => {
    getSingleProducts(`${API}/${id}`);
  }, [id]);
  
if (!singleproduct || Object.keys(singleproduct).length === 0) {
  return <div>Loading...</div>; // or a spinner
}
  const{
    category,
    subcategory,
    Item,
    SKU,
    name,
    size: { length, width, height } = {},
    packing,
    HSCode,
    type,
    wallDistance,
    TapHole,
    outletDia,
    OverFlow,
    finish,
    weight,
    price,
    star,
    Feature,
    main,
    featureImage
  }=singleproduct;
 

return (

  <Wrapper>
      <PageNavigation title={SKU} />
      <div className="container">
       <div className=" product-container">
         <MyImage imgs={singleproduct.featureImage} main={singleproduct.main} />

          <div className="product-data">
            <h2>{SKU} {name}</h2>
            <h3>{subcategory?.label}</h3>
            <Star star={star} />
            <p className="product-data-price">
              MRP:
              <del>
                <FormatPrice price={parseFloat(price/0.80)} user={auth} />
              </del>
            </p>
            <p className="product-data-price product-data-real-price">
              Deal of the Day: <FormatPrice price={price} user={auth}/>
            </p>
            
            <p className="product-data-info"> <ProductDetailsTable
              data={{
                Item,
                type,
                finish,
                HSCode,
                size: {Length: length ? `${length} mm` : null,
                        Width: width ? `${width} mm` : null,
                        Height: height ? `${height} mm` : null,
                      },
                wallDistance,
                outletDia,
                TapHole,
                OverFlow,
                weight: `${weight} kgs`,               
                packing,
                Feature,
              }}
              
            />
            <p className="infoNote">Note: All images and dimensions are indicative and may vary due to 
              ongoing development aimed at improving product quality and performance.<br/>
              Dimensions are indicative in millimetres (mm). <br/>
              Tolerance for vitreous fireclay items: ±5% for dimensions below 200 mm and ±3% for dimensions above 200 mm.<br/>
              Tolerance for all other items: ±1%.</p>
            </p>
            
            <div className="product-data-warranty">
              <div className="product-warranty-data">
                <TbTruckDelivery/>
                <p>FOB Mundra (India)</p>
              </div>

              <div className="product-warranty-data">
                <GiCargoShip />
                <p>Sea/air Freight would be Extra </p>
              </div>

              <div className="product-warranty-data">
                <MdSecurity />
                <p>2 Year Warranty </p>
              </div>
              
              <div className="product-warranty-data">
                <TbReplace />
                <p>30 Days Replacement</p>
              </div>

            </div>
            <AddtoCart products={singleproduct} isLoggedIn={auth?.isLoggedIn}/>
          </div>
        </div>
      </div>
    </Wrapper>
);


};



const Wrapper = styled.section`

margin:1rem;

.container{ 
    padding: 6rem ;

.product-container{
    display:grid;
    grid-template-columns:repeat(2, 1fr);
    }

.product_images{
    align-items:center;

    .product-dimension-image{
    width:130px;
    height:150px;
    }      
  }
  
.product-image{
    width:250px;
    height:350px;
    display: flex;
    align-items: center;
    justify-content: center;      
    }   
}

.product-data {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 1rem;

.infoNote{
    font-size: 10px;
    margin: 0.5rem;
    }
        
.product-data-warranty {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    margin-bottom: 1rem;
    padding : 2rem;
    gap:2rem;
    }

.product-warranty-data {
    text-align: center;
    }
  
.product-warranty-data p {
    font-size: 1.4rem;
    padding-top: 0.4rem;
    }

.product-data-price {
    font-weight: bold;
    }

.product-data-real-price {
    color: ${({ theme }) => theme.colors.btn};
    }
 
.product-data-info {
    width:100%;
    }
  }

hr {
    max-width: 100%;
    width: 90%;
    border: 0.1rem solid #000;
    }
  }
}

th, td {
  padding:  0 1rem;  
  
  }

@media (max-width: ${({ theme }) => theme.media.mobile}) {
 margin:2rem;
 
h2{
  font-size:2.2rem;
  margin-top:10%;
  } 
 
.container{
   padding: 1rem ;

.product-container{
   display:grid;
   grid-template-columns:repeat(1, 1fr);
   justify-content: center;
   }
  }
  
`;

export default SingleProduct;
